import React from 'react';
import { EDaysShort, weekDaysOptionsFull } from 'common/models/commonModel';
import {
  EPromoBonusType,
  EPromoBonusTypeText,
  EPromoCriteriaType,
  EPromoCriteriaTypeText,
  EPromoCustomerSelectType,
  EPromoCustomerSelectTypeText,
  EPromoPeriodText,
  EPromoType,
  EPromoTypeText,
} from 'entities/Promo/Promo.models';

export const selectBonus = (bonus?: EPromoBonusType): any => {
  switch (bonus) {
    case EPromoBonusType.DiscountAllPercent:
      return EPromoBonusTypeText.DiscountAllPercent;

    case EPromoBonusType.DiscountAllPeso:
      return EPromoBonusTypeText.DiscountAllPeso;

    case EPromoBonusType.DiscountItem:
      return EPromoBonusTypeText.DiscountItem;

    case EPromoBonusType.Additional:
      return EPromoBonusTypeText.Additional;

    case EPromoBonusType.AdditionalNotOnMenu:
      return EPromoBonusTypeText.AdditionalNotOnMenu;

    case EPromoBonusType.DoubleBitecoins:
      return EPromoBonusTypeText.DoubleBitecoins;

    case EPromoBonusType.BitecoinsReward:
      return EPromoBonusTypeText.BitecoinsReward;

    default:
      return 'Unknown bonus';
  }
};
export const selectCriteria = (bonus?: EPromoCriteriaType): any => {
  switch (bonus) {
    case EPromoCriteriaType.MenuItem:
      return EPromoCriteriaTypeText.MenuItem;

    case EPromoCriteriaType.Category:
      return EPromoCriteriaTypeText.Category;

    case EPromoCriteriaType.Price:
      return EPromoCriteriaTypeText.Price;
    case EPromoCriteriaType.EveryXPesos:
      return EPromoCriteriaTypeText.EveryXPesos;
    default:
      return 'Unknown criteria';
  }
};
export const selectPromoType = (promoType?: string): EPromoTypeText => {
  switch (promoType) {
    case EPromoType.Code:
      return EPromoTypeText.Code;
    // MB-2753: without this case a Referral promo was rendered as "Auto-apply"
    // in the promo list and on the edit page.
    case EPromoType.Referral:
      return EPromoTypeText.Referral;
    default:
      return EPromoTypeText.Action;
  }
};

export const selectCustomerType = (
  promoType: EPromoType | undefined,
  customerType?: string
): EPromoCustomerSelectTypeText => {
  if (promoType === EPromoType.Refund) {
    return EPromoCustomerSelectTypeText.PesooffPromoCustomers;
  }

  switch (customerType) {
    case EPromoCustomerSelectType.New:
      return EPromoCustomerSelectTypeText.New;
    case EPromoCustomerSelectType.All:
      return EPromoCustomerSelectTypeText.All;
    default:
    case EPromoCustomerSelectType.Specific:
      return EPromoCustomerSelectTypeText.Specific;
  }
};

export const selectPromoPeriodText = (
  promoType: EPromoType | undefined,
  startTimeValue: string | null | undefined,
  endTimeValue: string | null | undefined
) => {
  if (promoType === EPromoType.Refund) {
    return EPromoPeriodText.pesooffPromoPeriod;
  }

  // MB-2753: Referral promos have no period by spec (locked to "None").
  if (promoType === EPromoType.Referral) {
    return 'None';
  }

  if (startTimeValue && endTimeValue) {
    return EPromoPeriodText.specificDateAndTime;
  }

  return EPromoPeriodText.specificDate;
};

export const selectWeekDaysText = (weekDays: EDaysShort[] | undefined) => {
  if (!weekDays || !weekDays.length) {
    return '-';
  }

  const allDays = weekDaysOptionsFull.map((opt) => opt.value).sort();
  const sortedInput = [...weekDays].sort();

  // In case when all days selected
  if (JSON.stringify(sortedInput) === JSON.stringify(allDays)) {
    return 'Every Day';
  }

  // Map values to human-readable labels
  const labels = weekDays.map((day) => weekDaysOptionsFull.find((opt) => opt.value === day)?.label);

  // Get string with 'and'
  if (labels.length === 1) {
    return (
      <span>
        Every <span className="font-weight-5">{labels[0]}</span>
      </span>
    );
  } else if (labels.length === 2) {
    return (
      <span>
        Every <span className="font-weight-5">{labels[0]}</span> and <span className="font-weight-5">{labels[1]}</span>
      </span>
    );
  } else {
    const last = labels.pop();

    return (
      <span>
        Every <span className="font-weight-5">{labels.join(', ')}</span>, and{' '}
        <span className="font-weight-5">{last}</span>
      </span>
    );
  }
};
